import React, { useCallback, useRef, useState } from "react";
import styled from "styled-components";

interface DragAndDropProps {
  handleDropParent: (files: FileList) => void;
  onDragIn: () => void;
  onDragOut: () => void;
  children?: JSX.Element | JSX.Element[];
}

const DropArea = styled("div")<{ dragging: boolean }>`
  border: ${(props) => (props.dragging ? "dashed grey 1px" : "")};
`;

const DropContainer = styled.div`
    display:block;
`;
export const DragAndDrop: React.FC<DragAndDropProps> = ({
  handleDropParent,
  onDragIn,
  onDragOut,
  children,
}) => {
  const [dragging, setDragging] = useState(false);
  const [dragCounter, setDragCounter] = useState(0);
  const [ref] = useHookWithRefCallback();

  function useHookWithRefCallback() {
    const ref = useRef<HTMLDivElement | null>(null);
    const setRef = useCallback((node) => {
      if (ref.current) {
        // Make sure to cleanup any events/references added to the last instance
        ref.current.removeEventListener("dragenter", handleDragIn);
        ref.current.removeEventListener("dragleave", handleDragOut);
        ref.current.removeEventListener("dragover", handleDrag);
        ref.current.removeEventListener("drop", handleDrop);
      }

      if (node) {
        // Check if a node is actually passed. Otherwise node would be null.
        // You can now do what you need to, addEventListeners, measure, etc.

        let div = node;
        div.addEventListener("dragenter", handleDragIn);
        div.addEventListener("dragleave", handleDragOut);
        div.addEventListener("dragover", handleDrag);
        div.addEventListener("drop", handleDrop);
      }

      // Save a reference to the node
      ref.current = node;
    }, []);

    return [setRef];
  }

  function handleDrag(e: DragEvent) {
    e.preventDefault();
    e.stopPropagation();
  }
  function handleDragIn(e: DragEvent) {
    e.preventDefault();
    e.stopPropagation();
    setDragCounter(dragCounter + 1);
    if (
      e &&
      e.dataTransfer &&
      e.dataTransfer.items &&
      e.dataTransfer.items.length > 0
    ) {
      setDragging(true);
      onDragIn()
    }
  }
  function handleDragOut(e: DragEvent) {
    e.preventDefault();
    e.stopPropagation();
    setDragCounter(dragCounter - 1);
    if (dragCounter === 0) {
      setDragging(false);
      onDragOut();
    }
  }
  function handleDrop(e: DragEvent) {
    e.preventDefault();
    e.stopPropagation();
    setDragging(false);
    if (
      e &&
      e.dataTransfer &&
      e.dataTransfer.files &&
      e.dataTransfer.files.length > 0
    ) {
      handleDropParent(e.dataTransfer.files);
      e.dataTransfer.clearData();
      setDragCounter(0);
    }
  }

  return (
    <DropContainer ref={ref}>
      <DropArea dragging={dragging} >
      {children}
      </DropArea>
    </DropContainer>
  );
};
